export default __webpack_public_path__ + "static/media/inner_profile_pic.d687348e.png";